import React from "react";
import AllUnitOfMeasurements from "./UnitOfMeasurementModule/AllUnitOfMeasurement";
const UnitOfMeasurements = () => {
  return (
    <div>
      <AllUnitOfMeasurements />
    </div>
  );
};

export default UnitOfMeasurements;
